import axios from 'axios'

const API_BASE_URL = 'https://api.programmingalternatives.com/api'

const geolocationAxios = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Basic Mzo5ODUxRjgwODNERTI1Q0QwNUFDOTBDMzI4RjQ3MTFENDlDRURGNDE5OEI1NkIzQTZDQkY2MEY4RjBGMjUzREVD'
  }
})

interface IPDetectionResponse {
  ip?: string
}

interface LocationResponse {
  success?: boolean
  city?: {
    Country?: {
      Name?: string
      IsoCode?: string
    }
    Name?: string
  }
}

export const geolocationService = {
  ip2Location: async (ip: string): Promise<LocationResponse> => {
    const urlMethod = '/v1/GeoMap/IpToLocation'
    const response = await geolocationAxios.post<LocationResponse>(urlMethod, { ip })
    return response.data
  },

  detectIP: async (): Promise<IPDetectionResponse> => {
    const urlMethod = '/v1/GeoMap/DetectIP'
    const response = await geolocationAxios.get<IPDetectionResponse>(urlMethod)
    return response.data
  }
}

export default geolocationService

